module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0021.jpg?v=df7bc3d5";